module.exports = __webpack_public_path__ + "static/img/lianjie.1835221f.png";